import { createContext, useContext } from "react";

// What the Orders list's select column reads (#473). Its header and cells are
// module-level components, so TanStack renders the same element type every
// time and keeps each checkbox mounted (an inline function is a new component
// on every render: each box would remount and a keyboard user would lose
// focus). The page's selection reaches them through this context instead of
// a closure.
export interface OrderSelectionValue {
    selectedIds: ReadonlySet<string>;
    // Every row on the page is ticked; some, but not every, row is.
    allSelected: boolean;
    partlySelected: boolean;
    // The page has no rows to tick.
    isEmpty: boolean;
    isRunning: boolean;
    isListLoading: boolean;
    toggleRow: (id: string) => void;
    toggleAll: () => void;
}

export const OrderSelectionContext = createContext<OrderSelectionValue | null>(
    null,
);

export const useOrderSelection = (): OrderSelectionValue => {
    const value = useContext(OrderSelectionContext);
    if (!value) {
        throw new Error(
            "useOrderSelection must be used inside OrderSelectionContext.",
        );
    }
    return value;
};
